import React from 'react';
import { Link } from 'react-router-dom';

// 1. استيراد الـ hooks والأيقونات ومكون Icon
import { useState } from 'react'
import { useApp } from '../../contexts/AppContext';
import { useAuth } from '../../hooks/useAuth';
import Icon from '../common/Icon'; // استيراد مكوننا الجديد
import { FaBars, FaBell, FaUserCircle } from 'react-icons/fa'; // استيراد الأيقونات كقيم
import NotificationsDropdown from '../notifications/NotificationsDropdown';
// 2. إنشاء ملف CSS للمكون
import styles from './Layout.module.css'; // يمكننا إعادة استخدام نفس ملف CSS للتخطيط

// 1. تعريف الواجهة للـ props
interface HeaderProps {
  title: string;
}
const Header: React.FC<HeaderProps> = ({ title }) => {
  const { toggleSidebar } = useApp();
  const { user } = useAuth();
   const { 
    notifications, 
    unreadCount, 
    markNotificationAsRead, 
    markAllNotificationsAsRead 
  } = useApp();
  
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  
        <h2 className={styles.pageTitle}>{title}</h2>

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        {/* 3. استخدام مكون Icon لأيقونة القائمة */}
        <button onClick={toggleSidebar} className={styles.menuButton}>
           {/* لاحظ التغيير هنا */}
        <Icon as={FaBars} style={styles.icon} />
        </button>
        <h2 className={styles.pageTitle}>{title}</h2>
      </div>
      
      <div className={styles.headerRight}>
        <button className={styles.iconButton}>
          {/* استخدام مكون Icon لأيقونة الإشعارات */}
           {/* لاحظ التغيير هنا */}
           <div className={styles.notificationWrapper}>
          <button 
            className={styles.iconButton} 
            onClick={() => setDropdownOpen(!isDropdownOpen)}
          >
            <Icon as={FaBell} />
            {unreadCount > 0 && (
              <span className={styles.badge}>{unreadCount}</span>
            )}
          </button>
          {isDropdownOpen && (
            <NotificationsDropdown
              notifications={notifications}
              onMarkAsRead={markNotificationAsRead}
              onMarkAllAsRead={markAllNotificationsAsRead}
            />
          )}
        </div>
        <Icon as={FaBars} style={styles.icon} />
          <span className={styles.badge}>3</span> {/* مثال على شارة الإشعارات */}
        </button>
        
        <Link to="/profile" className={styles.profileLink}>
          <span>{user?.name}</span>
          {/* استخدام مكون Icon لأيقونة المستخدم */}
           {/* لاحظ التغيير هنا */}
           <Icon as={FaBars} style={styles.icon} />
        
        </Link>
      </div>
    </header>
  );
};

export default Header;
